<template>
  <v-card :class="{ 'pa-0': isEmbedded }" :flat="isEmbedded">
    <v-card-title
      v-if="!isEmbedded"
      :class="{
        headline: true,
        primary: true,
        'lighten-1': !isEmbedded,
        'darken-1': isEmbedded,
      }"
    >
      <slot name="title" :entity="data">
        <v-row justify-space-between>
          <v-col class="pa-0 px-4 align-self-center">
            <span class="white--text">
              {{ $t(`${localeGroupKey}.subTitle${canUpdate ? (creationMode ? "Create" : "Update") : "View"}`) }}
            </span>
          </v-col>
          <v-col class="pa-0 px-4" cols="auto">
            <slot name="actions" :entity="data" />
          </v-col>
        </v-row>
      </slot>
    </v-card-title>

    <v-layout wrap justify-space-between>
      <v-container :class="{ 'pa-0': isEmbedded }" grid-list-xs>
        <v-form ref="form" @submit.stop="">
          <slot name="form" :entity="data" />
        </v-form>
      </v-container>
    </v-layout>

    <core-ownerships
      v-if="!hideActions"
      class="pr-4"
      :value="data"
      large
    />

    <v-card-actions v-if="!hideActions">
      <v-layout class="pb-2">
        <v-flex grow>
          <slot name="buttons" />
        </v-flex>

        <v-flex shrink>
          <v-btn
            v-if="canUpdate"
            color="success"
            :disabled="isUpdateDisabled"
            @click="updateData"
          >
            {{ creationMode ? $t("common.save") : $t("common.update") }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import EditFormMixin from '../../mixins/editForm';

export default {
  mixins: [
    EditFormMixin,
  ],

  props: {
    localeGroupKey: String,
    hideActions: Boolean,
  },
};
</script>
